import React, { useState, useMemo, createContext } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { tenantConfig } from '../config/tenantConfig'; // 🚨 Moved to the top!

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

export const CustomThemeProvider = ({ children }) => {
    const [mode, setMode] = useState(localStorage.getItem('themeMode') || 'light');

    const colorMode = useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) => {
                    const newMode = prevMode === 'light' ? 'dark' : 'light';
                    localStorage.setItem('themeMode', newMode);
                    return newMode;
                });
            },
        }),
        [],
    );

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                    ...(mode === 'light'
                        ? {
                            // 🚨 THE FIX: Read from tenantConfig instead of hardcoding purple!
                            primary: { main: tenantConfig.primaryColor },
                            secondary: { main: '#2575fc' },
                            background: { default: '#f4f6f8', paper: '#ffffff' },
                          }
                        : {
                            // 🚨 Synced dark mode to also use the tenant's primary color
                            primary: { main: tenantConfig.primaryColor }, 
                            secondary: { main: '#03dac6' },
                            background: { 
                                default: '#121212', 
                                paper: '#1e1e1e'   
                            },
                            text: {
                                primary: '#ffffff',
                                secondary: 'rgba(255, 255, 255, 0.7)',
                            }
                          }),
                },
            }),
        [mode],
    );

    return (
        <ColorModeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>
                {children}
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
};